import React, { useState, useRef, useEffect } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './GuestJourney.css';
import OptimizedImage from './OptimizedImage';
import discoverMainImg from 'url:../../assets-optimized/redesign/journey/discover_main.jpg';
import discoverMainImgavif from 'url:../../assets-optimized/redesign/journey/discover_main.avif';
import discoverMainImgwebp from 'url:../../assets-optimized/redesign/journey/discover_main.webp';
import discoverSecondaryImg from 'url:../../assets-optimized/redesign/journey/discovery_secondary.png';
import discoverSecondaryImgavif from 'url:../../assets-optimized/redesign/journey/discovery_secondary.avif';
import discoverSecondaryImgwebp from 'url:../../assets-optimized/redesign/journey/discovery_secondary.webp';
import planMainImg from 'url:../../assets-optimized/redesign/journey/plan_main.jpg';
import planMainImgavif from 'url:../../assets-optimized/redesign/journey/plan_main.avif';
import planMainImgwebp from 'url:../../assets-optimized/redesign/journey/plan_main.webp';
import planSecondaryImg from 'url:../../assets-optimized/redesign/journey/plan_secondary.png';
import planSecondaryImgavif from 'url:../../assets-optimized/redesign/journey/plan_secondary.avif';
import planSecondaryImgwebp from 'url:../../assets-optimized/redesign/journey/plan_secondary.webp';
import arriveMainImg from 'url:../../assets-optimized/redesign/journey/arrive_main.png';
import arriveMainImgavif from 'url:../../assets-optimized/redesign/journey/arrive_main.avif';
import arriveMainImgwebp from 'url:../../assets-optimized/redesign/journey/arrive_main.webp';
import arriveSecondaryImg from 'url:../../assets-optimized/redesign/journey/arrive_secondary.png';
import arriveSecondaryImgavif from 'url:../../assets-optimized/redesign/journey/arrive_secondary.avif';
import arriveSecondaryImgwebp from 'url:../../assets-optimized/redesign/journey/arrive_secondary.webp';
import relaxMainImg from 'url:../../assets-optimized/redesign/journey/relax_main.png';
import relaxMainImgavif from 'url:../../assets-optimized/redesign/journey/relax_main.avif';
import relaxMainImgwebp from 'url:../../assets-optimized/redesign/journey/relax_main.webp';
import relaxSecondaryImg from 'url:../../assets-optimized/redesign/journey/relax_secondary.png';
import relaxSecondaryImgavif from 'url:../../assets-optimized/redesign/journey/relax_secondary.avif';
import relaxSecondaryImgwebp from 'url:../../assets-optimized/redesign/journey/relax_secondary.webp';
import exploreMainImg from 'url:../../assets-optimized/redesign/journey/explore_main.png';
import exploreMainImgavif from 'url:../../assets-optimized/redesign/journey/explore_main.avif';
import exploreMainImgwebp from 'url:../../assets-optimized/redesign/journey/explore_main.webp';
import exploreSecondaryImg from 'url:../../assets-optimized/redesign/journey/explore_secondary.png';
import exploreSecondaryImgavif from 'url:../../assets-optimized/redesign/journey/explore_secondary.avif';
import exploreSecondaryImgwebp from 'url:../../assets-optimized/redesign/journey/explore_secondary.webp';

const GlobeIcon = ({ fill = 'white', stroke = '#171717' }) => (
  <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='16' cy='16' r='16' fill={fill} />
    <g clipPath='url(#clip0_1362_2662)'>
      <path
        d='M8.125 16C8.125 18.0886 8.95469 20.0916 10.4315 21.5685C11.9084 23.0453 13.9114 23.875 16 23.875C18.0886 23.875 20.0916 23.0453 21.5685 21.5685C23.0453 20.0916 23.875 18.0886 23.875 16C23.875 13.9114 23.0453 11.9084 21.5685 10.4315C20.0916 8.95469 18.0886 8.125 16 8.125C13.9114 8.125 11.9084 8.95469 10.4315 10.4315C8.95469 11.9084 8.125 13.9114 8.125 16Z'
        stroke={stroke}
        strokeWidth='1.5'
        strokeLinejoin='round'
      />
      <path
        d='M12.625 16C12.625 13.9114 12.9806 11.9084 13.6135 10.4315C14.2465 8.95469 15.1049 8.125 16 8.125C16.8951 8.125 17.7535 8.95469 18.3865 10.4315C19.0194 11.9084 19.375 13.9114 19.375 16C19.375 18.0886 19.0194 20.0916 18.3865 21.5685C17.7535 23.0453 16.8951 23.875 16 23.875C15.1049 23.875 14.2465 23.0453 13.6135 21.5685C12.9806 20.0916 12.625 18.0886 12.625 16Z'
        stroke={stroke}
        strokeWidth='1.5'
        strokeLinejoin='round'
      />
      <path
        d='M8.6875 18.625H23.3125M8.6875 13.375H23.3125'
        stroke={stroke}
        strokeWidth='1.5'
        strokeLinecap='round'
      />
    </g>
    <defs>
      <clipPath id='clip0_1362_2662'>
        <rect width='18' height='18' fill='white' transform='translate(7 7)' />
      </clipPath>
    </defs>
  </svg>
);

const UserIcon = () => (
  <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='16' cy='16' r='16' fill='white' />
    <path
      d='M23.9115 15.9987C23.9115 18.0983 23.0774 20.112 21.5927 21.5966C20.1081 23.0813 18.0944 23.9154 15.9948 23.9154C14.6381 23.9154 13.3615 23.5737 12.2448 22.9729C10.6881 22.1337 9.64063 22.9137 8.71646 23.0537C8.64736 23.0636 8.57689 23.057 8.51083 23.0344C8.44478 23.0118 8.38502 22.9739 8.33646 22.9237C8.26396 22.8467 8.21599 22.7499 8.19863 22.6456C8.18126 22.5413 8.19531 22.4342 8.23896 22.3379C8.6023 21.4837 8.9348 19.8637 8.48063 18.4987C8.21319 17.6924 8.07729 16.8482 8.07813 15.9987C8.07813 13.8991 8.9122 11.8854 10.3969 10.4008C11.8815 8.91611 13.8952 8.08203 15.9948 8.08203C18.0944 8.08203 20.1081 8.91611 21.5927 10.4008C23.0774 11.8854 23.9115 13.8991 23.9115 15.9987Z'
      stroke='#171717'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12 20C12 19.5096 12.1035 19.024 12.3045 18.5709C12.5055 18.1179 12.8001 17.7062 13.1716 17.3594C13.543 17.0127 13.984 16.7376 14.4693 16.5499C14.9546 16.3623 15.4747 16.2657 16 16.2657C16.5253 16.2657 17.0454 16.3623 17.5307 16.5499C18.016 16.7376 18.457 17.0127 18.8284 17.3594C19.1999 17.7062 19.4945 18.1179 19.6955 18.5709C19.8965 19.024 20 19.5096 20 20M18.2857 14.1339C18.2857 14.6998 18.0449 15.2426 17.6162 15.6428C17.1876 16.043 16.6062 16.2678 16 16.2678C15.3938 16.2678 14.8124 16.043 14.3838 15.6428C13.9551 15.2426 13.7143 14.6998 13.7143 14.1339C13.7143 13.568 13.9551 13.0252 14.3838 12.625C14.8124 12.2248 15.3938 12 16 12C16.6062 12 17.1876 12.2248 17.6162 12.625C18.0449 13.0252 18.2857 13.568 18.2857 14.1339Z'
      stroke='#171717'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const PhoneIcon = () => (
  <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='16' cy='16' r='16' fill='white' />
    <path
      d='M22.75 16V18.25C22.75 19.4435 22.2759 20.5881 21.432 21.432C20.5881 22.2759 19.4435 22.75 18.25 22.75H13.75C12.5565 22.75 11.4119 22.2759 10.568 21.432C9.72411 20.5881 9.25 19.4435 9.25 18.25V13.75C9.25 12.5565 9.72411 11.4119 10.568 10.568C11.4119 9.72411 12.5565 9.25 13.75 9.25H16M21.25 13C21.8467 13 22.419 12.7629 22.841 12.341C23.2629 11.919 23.5 11.3467 23.5 10.75C23.5 10.1533 23.2629 9.58097 22.841 9.15901C22.419 8.73705 21.8467 8.5 21.25 8.5C20.6533 8.5 20.081 8.73705 19.659 9.15901C19.2371 9.58097 19 10.1533 19 10.75C19 11.3467 19.2371 11.919 19.659 12.341C20.081 12.7629 20.6533 13 21.25 13Z'
      stroke='#171717'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const WifiIcon = ({ fill = '#24ADE9' }) => (
  <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='16' cy='16' r='16' fill={fill} />
    <path
      d='M8.5 14.1119C12.7023 10.1294 19.2977 10.1294 23.5 14.1119'
      stroke='white'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M21.25 16.6752C18.3505 13.7749 13.6495 13.7749 10.75 16.6752M19 19.1179C18.2043 18.3223 17.1252 17.8753 16 17.8753C14.8748 17.8753 13.7957 18.3223 13 19.1179M16 21.4377V21.0627'
      stroke='white'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const TvIcon = () => (
  <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='16' cy='16' r='16' fill='var(--bonvoy-coral)' />
    <g clipPath='url(#clip0_1362_2986)'>
      <path
        d='M19 23.5C18.0778 23.0046 17.0468 22.7469 16 22.75C14.9532 22.7469 13.9222 23.0046 13 23.5M8.5 14.5C8.5 11.6718 8.5 10.2572 9.379 9.379C10.258 8.50075 11.6718 8.5 14.5 8.5H17.5C20.3282 8.5 21.7427 8.5 22.621 9.379C23.4992 10.258 23.5 11.6718 23.5 14.5C23.5 17.3282 23.5 18.7427 22.621 19.621C21.742 20.4992 20.3282 20.5 17.5 20.5H14.5C11.6718 20.5 10.2572 20.5 9.379 19.621C8.50075 18.742 8.5 17.3282 8.5 14.5Z'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
      />
    </g>
    <defs>
      <clipPath id='clip0_1362_2986'>
        <rect width='18' height='18' fill='white' transform='translate(7 7)' />
      </clipPath>
    </defs>
  </svg>
);

const journeySteps = [
  {
    id: 'Discovery',
    title: 'Inspire travelers during the search',
    mobileTitle: 'Discover',
    text: 'Capture open attention and elevate the traveler’s purpose with your brand offering.',
    image: { avif: discoverMainImgavif, webp: discoverMainImgwebp, fallback: discoverMainImg },
    secondaryImage: {
      avif: discoverSecondaryImgavif,
      webp: discoverSecondaryImgwebp,
      fallback: discoverSecondaryImg,
    },
    bgColor: '#ffffff',
    textColor: '#1c1c1c',
    tagColor: '#fff',
    tagBgColor: '#545454',
    pills: [
      {
        text: 'Marriott.com & Hotel Websites',
        icon: <GlobeIcon />,
        position: {
          '--desk-top': '15%',
          '--desk-left': '-15%',
          '--mob-top': '-5%',
          '--mob-left': '-17%',
        },
      },
      {
        text: 'Paid social',
        icon: <UserIcon />,
        position: {
          '--desk-top': '55%',
          '--desk-left': '-5%',
          '--mob-top': '20%',
          '--mob-left': '-11%',
        },
      },
    ],
    secondaryImagePosition: {
      '--desk-bottom': '24%',
      '--desk-right': '-15%',
      '--desk-width': '200px',
      '--mob-bottom': '-10%',
      '--mob-right': '-5%',
      '--mob-width': '140px',
    },
  },
  {
    id: 'Booking',
    title: 'Be a part of Guest decisions',
    mobileTitle: 'Plan',
    text: 'Be front and center when known travelers are booking their transportation, stay and events.',
    image: { avif: planMainImgavif, webp: planMainImgwebp, fallback: planMainImg },
    secondaryImage: {
      avif: planSecondaryImgavif,
      webp: planSecondaryImgwebp,
      fallback: planSecondaryImg,
    },
    bgColor: '#E5E4E6',
    textColor: '#1c1c1c',
    tagColor: '#545454',
    tagBgColor: '#fff',
    pills: [
      {
        text: 'Marriott Bonvoy Emails',
        icon: <GlobeIcon />,
        position: {
          '--desk-top': '35%',
          '--desk-left': '-10%',
          '--mob-top': '40%',
          '--mob-left': '-15%',
        },
      },
      {
        text: 'Marriott Bonvoy App',
        icon: <PhoneIcon />,
        position: {
          '--desk-top': '25%',
          '--desk-right': '-10%',
          '--mob-top': '60%',
          '--mob-left': '-15%',
          '--mob-right': 'auto',
        },
      },
      {
        text: 'Paid social',
        icon: <UserIcon />,
        position: {
          '--desk-bottom': '15%',
          '--desk-right': '-10%',
          '--mob-bottom': '-5%',
          '--mob-right': '-8%',
          '--desk-top': 'auto',
          '--mob-top': 'auto',
        },
      },
    ],
    secondaryImagePosition: {
      '--desk-bottom': '10%',
      '--desk-left': '-12%',
      '--desk-width': '230px',
      '--mob-top': '-17%',
      '--mob-right': '-5%',
      '--mob-width': '160px',
      '--mob-bottom': 'auto',
      '--mob-left': 'auto',
      '--desk-top': 'auto',
    },
  },
  {
    id: 'PLANNING & PREP',
    title: 'Own the moment of deep attention',
    mobileTitle: 'Arrive',
    text: 'It’s common for travelers to spend as much on pre-trip goods as on the trip itself.',
    image: { avif: arriveMainImgavif, webp: arriveMainImgwebp, fallback: arriveMainImg },
    secondaryImage: {
      avif: arriveSecondaryImgavif,
      webp: arriveSecondaryImgwebp,
      fallback: arriveSecondaryImg,
    },
    bgColor: '#3baae3',
    textColor: '#1c1c1c',
    tagColor: '#fff',
    tagBgColor: '#1c1c1c',
    pills: [
      {
        text: 'Marriott Bonvoy App',
        icon: <WifiIcon />,
        position: {
          '--desk-bottom': '10%',
          '--desk-left': '-10%',
          '--mob-bottom': 'auto',
          '--mob-top': '60%',
          '--mob-left': '-15%',
          '--mob-right': 'auto',
        },
        style: {
          background: 'rgba(220, 243, 254, 0.85)',
          backdropFilter: 'blur(17px)',
          WebkitBackdropFilter: 'blur(17px)',
          color: '#171717',
        },
      },
      {
        text: 'Wi-Fi portal',
        icon: <WifiIcon fill={'var(--riot-media-blue)'} />,
        position: {
          '--desk-bottom': '75%',
          '--desk-right': '-10%',
          '--mob-bottom': '-9%',
          '--mob-right': '-10%',
          '--mob-top': 'auto',
        },
        style: {
          background: 'rgba(220, 243, 254, 0.85)',
          backdropFilter: 'blur(17px)',
          WebkitBackdropFilter: 'blur(17px)',
          color: '#171717',
        },
      },
    ],
    secondaryImagePosition: {
      '--desk-top': '20%',
      '--desk-left': '-17%',
      '--desk-width': '30%',
      '--mob-top': '-6%',
      '--mob-left': '-11%',
      '--mob-width': '120px',
      '--desk-bottom': 'auto',
      '--mob-bottom': 'auto',
    },
  },
  {
    id: 'Arrive & Explore',
    title: 'capture their mindset shift',
    mobileTitle: 'Relax',
    text: 'As guests unwind, attention deepens. This is premium territory for storytelling that builds affinity, moves preference, and influences spend during their stay.',
    image: { avif: relaxMainImgavif, webp: relaxMainImgwebp, fallback: relaxMainImg },
    secondaryImage: {
      avif: relaxSecondaryImgavif,
      webp: relaxSecondaryImgwebp,
      fallback: relaxSecondaryImg,
    },
    bgColor: 'var(--bonvoy-coral)',
    textColor: '#1c1c1c',
    tagColor: '#1c1c1c',
    tagBgColor: '#fff',
    pills: [
      {
        text: 'Guest room entertainment',
        icon: <TvIcon />,
        position: {
          '--desk-top': '15%',
          '--desk-left': '-25%',
          '--mob-top': '-5%',
          '--mob-left': '-16%',
        },
        style: {
          background: 'rgba(255, 224, 208, 0.85)',
          backdropFilter: 'blur(17px)',
          WebkitBackdropFilter: 'blur(17px)',
          color: '#171717',
        },
      },
    ],
    secondaryImagePosition: {
      '--desk-bottom': '15%',
      '--desk-right': '-10%',
      '--desk-width': '40%',
      '--mob-bottom': '-15%',
      '--mob-right': '-10%',
      '--mob-width': '140px',
      '--desk-top': 'auto',
      '--mob-top': 'auto',
    },
  },
  {
    id: 'Advocate',
    title: 'Follow up as they explore',
    mobileTitle: 'Reflect',
    text: 'The journey continues long after returning home. Marriott travelers are 1.5X more likely to turn discoveries into preferences.',
    image: { avif: exploreMainImgavif, webp: exploreMainImgwebp, fallback: exploreMainImg },
    secondaryImage: {
      avif: exploreSecondaryImgavif,
      webp: exploreSecondaryImgwebp,
      fallback: exploreSecondaryImg,
    },
    bgColor: '#1c1c1c',
    textColor: '#ffffff',
    tagColor: '#fff',
    tagBgColor: '#545454',
    pills: [
      {
        text: 'Offsite digital',
        icon: <UserIcon />,
        position: {
          '--desk-bottom': '70%',
          '--desk-left': '-10%',
          '--mob-bottom': '18%',
          '--mob-left': '-5%',
          '--desk-top': 'auto',
          '--mob-top': 'auto',
        },
      },
      {
        text: 'Marriott.com & Hotel Websites',
        icon: <GlobeIcon />,
        position: {
          '--desk-bottom': '10%',
          '--desk-left': '-15%',
          '--mob-bottom': '-5%',
          '--mob-left': '7%',
          '--desk-top': 'auto',
          '--mob-top': 'auto',
        },
      },
    ],
    secondaryImagePosition: {
      '--desk-bottom': '10%',
      '--desk-right': '-10%',
      '--desk-width': '230px',
      '--mob-top': '-15%',
      '--mob-right': '-5%',
      '--mob-width': '160px',
      '--mob-bottom': 'auto',
      '--desk-top': 'auto',
    },
  },
];

gsap.registerPlugin(ScrollTrigger);

const GuestJourney = () => {
  const [activeTab, setActiveTab] = useState(0);
  const stepsContainerRef = useRef(null);
  const tabsWrapperRef = useRef(null);
  const mobileStepRef = useRef(null);

  // Live horizontal offset (px) of the mobile card as the finger drags, plus a
  // flag toggling the settle transition on/off (off while tracking the finger).
  const [dragX, setDragX] = useState(0);
  const [sliding, setSliding] = useState(false);

  // Commit past this drag distance; below it the card springs back.
  const SWIPE_THRESHOLD = 50;
  const SLIDE_MS = 280;

  // Mobile swipe: the card follows the finger, then either springs back or
  // slides out in the swipe direction while the next step slides in from the
  // opposite edge. Native non-passive listeners let us preventDefault so a
  // horizontal drag doesn't also scroll the page vertically.
  useEffect(() => {
    const el = mobileStepRef.current;
    if (!el) return undefined;

    let startX = 0;
    let startY = 0;
    let dir = null; // 'h' | 'v' once the gesture direction is locked
    let active = false;
    let committing = false;

    const onStart = (e) => {
      if (committing) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      dir = null;
      active = true;
      setSliding(false);
    };

    const onMove = (e) => {
      if (!active) return;
      const dx = e.touches[0].clientX - startX;
      const dy = e.touches[0].clientY - startY;
      if (dir === null) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        dir = Math.abs(dx) > Math.abs(dy) ? 'h' : 'v';
      }
      if (dir === 'v') return;
      e.preventDefault();
      // Rubber-band resistance when dragging past the first/last step.
      const atEdge =
        (dx > 0 && activeTab === 0) || (dx < 0 && activeTab === journeySteps.length - 1);
      setDragX(atEdge ? dx * 0.3 : dx);
    };

    const onEnd = (e) => {
      if (!active) return;
      active = false;
      const dx = e.changedTouches[0].clientX - startX;
      const goNext = dx < 0 && activeTab < journeySteps.length - 1;
      const goPrev = dx > 0 && activeTab > 0;

      setSliding(true);

      if (dir === 'h' && Math.abs(dx) > SWIPE_THRESHOLD && (goNext || goPrev)) {
        const step = goNext ? 1 : -1;
        const width = el.clientWidth;
        committing = true;
        // Slide the current card fully out in the swipe direction.
        setDragX(-step * width);
        window.setTimeout(() => {
          // Swap content, drop the incoming card on the opposite edge with no
          // transition, then animate it home on the next frame.
          setSliding(false);
          setActiveTab(activeTab + step);
          setDragX(step * width);
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              setSliding(true);
              setDragX(0);
              committing = false;
            });
          });
        }, SLIDE_MS);
      } else {
        setDragX(0); // spring back
      }
      dir = null;
    };

    el.addEventListener('touchstart', onStart, { passive: true });
    el.addEventListener('touchmove', onMove, { passive: false });
    el.addEventListener('touchend', onEnd);
    return () => {
      el.removeEventListener('touchstart', onStart);
      el.removeEventListener('touchmove', onMove);
      el.removeEventListener('touchend', onEnd);
    };
  }, [activeTab]);

  // Keep the active pill tab visible in the horizontally scrollable nav as the
  // step changes (e.g. via swipe), centering it within the scroll viewport.
  useEffect(() => {
    const wrapper = tabsWrapperRef.current;
    if (!wrapper) return;
    const btn = wrapper.querySelector('.journey-tab-btn.active');
    if (!btn) return;
    const wrapRect = wrapper.getBoundingClientRect();
    const btnRect = btn.getBoundingClientRect();
    const delta = btnRect.left - wrapRect.left - (wrapper.clientWidth - btn.clientWidth) / 2;
    wrapper.scrollTo({ left: wrapper.scrollLeft + delta, behavior: 'smooth' });
  }, [activeTab]);

  // Tablet+ "3D stacked cards" scroll effect: each step is pinned (position:
  // sticky) and, as the next step slides up to cover it, the underlying step
  // scales down, fades, and tilts back so it appears to recede. Driven by
  // ScrollTrigger's scrub so the receding tracks scroll progress exactly.
  useEffect(() => {
    const container = stepsContainerRef.current;
    if (!container) return undefined;

    const mm = gsap.matchMedia();

    // On tablet and up, and only when the user hasn't asked for less motion.
    mm.add('(min-width: 768px) and (prefers-reduced-motion: no-preference)', () => {
      const cards = gsap.utils.toArray('.journey-step', container);

      cards.forEach((card, i) => {
        // The last (top-most) card is never covered, so it never recedes.
        if (i === cards.length - 1) return;

        const nextCard = cards[i + 1];

        gsap.fromTo(
          card,
          { scale: 1, opacity: 1, rotateX: 0 },
          {
            scale: 0.95,
            // Fully transparent once it's completely tucked behind the next card.
            opacity: 0,
            rotateX: 5,
            ease: 'none',
            scrollTrigger: {
              // Progress runs from the moment the next card's top reaches this
              // (pinned) card's bottom edge — i.e. it starts covering it — until
              // it's scrolled all the way to the top and fully covers it.
              trigger: nextCard,
              start: () => `top ${card.offsetHeight}px`,
              end: 'top top',
              scrub: true,
              invalidateOnRefresh: true,
            },
          }
        );
      });
    });

    return () => mm.revert();
  }, []);

  const scrollToFirstStep = () => {
    // offsetParent is null when the element (or an ancestor) is display:none,
    // so this picks whichever container is actually visible at the current breakpoint.
    let element = document.getElementById('journey-step-Discovery');
    if (!element || element.offsetParent === null) {
      element = document.getElementById('journey-steps-mobile');
    }
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const renderImageSection = (step) => (
    <div className='journey-step-image-wrapper'>
      <div className='journey-step-image'>
        <OptimizedImage
          avif={step.image.avif}
          webp={step.image.webp}
          fallback={step.image.fallback}
          alt={step.title}
          className='main-journey-img'
        />
        {step.secondaryImage && (
          <OptimizedImage
            avif={step.secondaryImage.avif}
            webp={step.secondaryImage.webp}
            fallback={step.secondaryImage.fallback}
            alt={`${step.title} secondary`}
            className='secondary-journey-img'
            style={step.secondaryImagePosition}
          />
        )}
        {step.pills &&
          step.pills.map((pill, idx) => (
            <div
              key={idx}
              className='journey-image-pill'
              style={{ ...pill.position, ...pill.style }}
            >
              <span className='pill-icon'>{pill.icon}</span>
              <span className='pill-text'>{pill.text}</span>
            </div>
          ))}
      </div>
    </div>
  );

  return (
    <section className='redesign-guest-journey'>
      <div className='guest-journey-content'>
        <h2 className='guest-journey-title'>
          WHEN INTENT PEAKS
          <br className='desktop-only' /> YOUR INFLUENCE REIGNS
        </h2>
        <p className='guest-journey-text'>
          Tap into high-intent traveler behavior and deliver your brand message at the exact moments
          when decisions are made&mdash;and dollars move.
        </p>
        <div className='scroll-down-arrow' onClick={scrollToFirstStep}>
          <svg
            width='64'
            height='64'
            viewBox='0 0 64 64'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <circle cx='32' cy='32' r='31.5' stroke='#8F8F8F' />
            <path
              d='M31.8281 19.2253L31.8281 42.5586'
              stroke='#171717'
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M19.5976 30.9966L31.8276 43.2266L44.7968 30.2574'
              stroke='#171717'
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        </div>
      </div>

      {/* Mobile pill tabs navigation */}
      <div className='journey-tabs-wrapper' id='journey-steps-mobile' ref={tabsWrapperRef}>
        <div className='journey-tabs-nav'>
          {journeySteps.map((step, index) => (
            <button
              key={step.id}
              className={`journey-tab-btn custom_click_track ${index === activeTab ? 'active' : ''}`}
              data-custom_click_track_value={`Guest Journey|Tab ${step.title}|Internal|`}
              onClick={() => setActiveTab(index)}
            >
              {step.mobileTitle}
            </button>
          ))}
        </div>
      </div>

      {/* Mobile: Show only active step */}
      <div className='journey-steps-mobile' ref={mobileStepRef}>
        {(() => {
          const step = journeySteps[activeTab];
          return (
            <div
              key='mobile-journey-step'
              className='journey-step'
              style={{
                backgroundColor: step.bgColor,
                color: step.textColor,
                transform: `translateX(${dragX}px)`,
                transition: sliding ? `transform ${SLIDE_MS}ms ease` : 'none',
              }}
            >
              <div className='journey-step-inner'>
                <div className='journey-step-text'>
                  <div
                    className='step-number'
                    style={{
                      background: step.tagBgColor,
                      color: step.tagColor,
                    }}
                  >
                    {String(activeTab + 1).padStart(2, '0')}
                  </div>
                  <h3 style={{ color: step.textColor }}>{step.mobileTitle}</h3>
                  <p style={{ color: step.textColor }}>{step.title}</p>
                </div>
                {renderImageSection(step)}
              </div>
            </div>
          );
        })()}
      </div>

      {/* Desktop/Tablet: Show all steps */}
      <div className='journey-steps-container' ref={stepsContainerRef}>
        {journeySteps.map((step) => (
          <div
            key={step.id}
            id={`journey-step-${step.id}`}
            className='journey-step'
            style={{ backgroundColor: step.bgColor }}
          >
            <div className='journey-step-inner'>
              <div className='journey-step-text'>
                <div
                  className='step-number'
                  style={{
                    backgroundColor: step.tagBgColor,
                    color: step.tagColor,
                  }}
                >
                  {step.id}
                </div>
                <h3 style={{ color: step.textColor }}>{step.title}</h3>
                <p style={{ color: step.textColor }}>{step.text}</p>
              </div>
              {renderImageSection(step)}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default GuestJourney;
